import { format, parseISO } from 'date-fns';

export function formatISODate(
  isoDate: string | null | undefined,
  formatStr: string,
  fallback?: string,
) {
  if (!isoDate) {
    return fallback ?? '';
  }

  return format(parseISO(isoDate), formatStr);
}

export function monthDayYear(
  date: Date | string | null | undefined,
  fallback?: string,
) {
  const formatString = 'MM/dd/yyyy';

  if (date instanceof Date) {
    return format(date, formatString);
  }

  return formatISODate(date, formatString, fallback);
}

export function writtenOutDate(date: Date | string | null | undefined) {
  const formatString = 'MMM d, yyyy';

  if (date instanceof Date) {
    return format(date, formatString);
  }

  return formatISODate(date, formatString);
}
